import React from "react"

function PricingB() {
  return (
    <svg viewBox="0 0 266 150" fill="none">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <rect
        x={110}
        y={20}
        width={46}
        height={5}
        rx={2.5}
        fill="var(--solid-900)"
      />
      <rect x={87} y={29} width={92} height={4} rx={2} fill="var(--base-500)" />
      <rect
        x={106}
        y={37}
        width={55}
        height={4}
        rx={2}
        fill="var(--base-500)"
      />
      <rect
        x={50}
        y={57}
        width={167}
        height={11}
        rx={1}
        fill="var(--base-200)"
      />
      <rect
        x={55}
        y={61}
        width={39}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={55}
        y={121}
        width={19}
        height={3}
        rx={1.5}
        fill="var(--main-500)"
      />
      <rect
        x={108}
        y={61}
        width={24}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={145}
        y={61}
        width={30}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={188}
        y={61}
        width={20}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect x={55} y={74} width={26} height={2} rx={1} fill="var(--base-500)" />
      <rect
        x={108}
        y={74}
        width={12}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <path
        d="M216.5 82a.5.5 0 010 1h-166a.5.5 0 010-1h166z"
        fill="var(--base-300)"
      />
      <rect
        x={145}
        y={74}
        width={13}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={188}
        y={74}
        width={20}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect x={55} y={89} width={39} height={2} rx={1} fill="var(--base-500)" />
      <rect
        x={108}
        y={89}
        width={17}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <path
        d="M216.5 97a.5.5 0 010 1h-166a.5.5 0 010-1h166z"
        fill="var(--base-300)"
      />
      <rect
        x={145}
        y={89}
        width={18}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={188}
        y={89}
        width={13}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={55}
        y={104}
        width={33}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={108}
        y={104}
        width={14}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <path
        d="M216.5 112a.5.5 0 010 1h-166a.5.5 0 010-1h166z"
        fill="var(--base-300)"
      />
      <rect
        x={182}
        y={119}
        width={31}
        height={10}
        rx={2}
        fill="var(--main-500)"
      />
      <rect
        x={145}
        y={104}
        width={18}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={188}
        y={104}
        width={20}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
    </svg>
  )
}

export default PricingB;
